import { DateRange }       from 'rewire-common';
import {
  Modal,
  Form,
  IFormContext,
  validator,
  field,
}                          from 'rewire-ui';
import { IGroup }          from '../DataTypes';
import DataMutations       from '../graphql/Mutations';
import mainPageModel       from '../main-navigation/MainPageModel';
import { getNameSearcher } from '../utility/Searchers';
import { notifications }   from '../ui/Notifications';

export interface IDuplicateGroupDialogData {
  group: IGroup;
}

export class DuplicateGroupDialogModel extends Modal {
  form:    Form;
  groupId?: string;

  constructor() {
    super('Duplicate Group');

    const areaSearcher = getNameSearcher('areas');

    this.form = Form.create((form: IFormContext) => ({
      name: form.string().label('Name').validators('required').placeholder('enter group name').autoFocus(),
      area: form.reference(areaSearcher).label('Area').validators('required'),
      startDate: form.date().label('Start Date').validators('required'),
      endDate: form.date().label('End Date').validators(validator('>=', field('startDate'))),
    }), {}, {updateOnChange: true});
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit', disabled: () => !this.form.hasChanges });
  }

  reset() {
    this.form.reset();
    this.groupId = undefined;
  }

  load(data: IDuplicateGroupDialogData) {
    this.reset();
    this.groupId    = data.group.id;
    this.form.value = {area: data.group.area};
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const groupId   = this.groupId!;
    const areaId    = this.form.field.area.value.id;
    const name      = this.form.field.name.value;
    const effective = new DateRange(this.form.field.startDate.value, this.form.field.endDate.value);

    const result = await DataMutations.duplicateGroup(areaId, groupId, name, effective);

    if (result) {
      notifications.success('Group Duplicated');
      mainPageModel.updateAreasAndGroups();
      return true;
    }

    notifications.error('Group Duplication Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const duplicateGroupDialogModel = new DuplicateGroupDialogModel();
export default duplicateGroupDialogModel;
